import { render, staticRenderFns } from "./PreviredAcepta.vue?vue&type=template&id=15ffdb45&scoped=true"
import script from "./PreviredAcepta.vue?vue&type=script&lang=js"
export * from "./PreviredAcepta.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./PreviredAcepta.vue?vue&type=style&index=0&id=15ffdb45&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "15ffdb45",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/fulfillment-previred-widget/fulfillment-previred-widget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15ffdb45')) {
      api.createRecord('15ffdb45', component.options)
    } else {
      api.reload('15ffdb45', component.options)
    }
    module.hot.accept("./PreviredAcepta.vue?vue&type=template&id=15ffdb45&scoped=true", function () {
      api.rerender('15ffdb45', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PreviredAcepta.vue"
export default component.exports